/** @type {import("@mui/material").SxProps<Theme>} */
const styles = theme => ({
  '&.MuiCardContent-root': {
    paddingBottom: '0 !impotant',
  },
  root: {
    '& .brand-carousel': {
      height: { xs: 'fit-content', md: 'fit-content' },
    },
    '& .brand-carousel .swiper-wrapper': {
      pt: 1,
      textAlign: 'center',
    },
    '& .brand-carousel .swiper-slide': {
      height: { xs: 84, md: 100 },
      width: { xs: 80, md: 90 },
      marginRight: { xs: '0' },
    },
    // '& .brand-carousel .swiper-slide img': {
    //   height: '100%',
    //   width: 'auto',
    // },
  },
  brandText: {
    color: theme.palette.secondary.mobileActiveToggleBackground,
  },
  cardContent: {
    [theme.breakpoints.down('sm')]: {
      pl: '.625rem',
      pr: '.625rem',
      pb: '0 !important',
    },
  },
  button: {
    objectFit: 'scale-down !important',
    textTransform: 'capitalize',
    borderRadius: '1000px',
    cursor: 'pointer',
    width: '74px',
    border: 0,
    padding: 0,
    height: '74px',
    background: theme.palette.secondary.contrastText,
    boxShadow: `0px 3px 5px -1px  ${theme.palette.primary.boxShadow2Dark}, 0px 5px 8px  ${theme.palette.primary.boxShadow2Medium}, 0px 1px 14px ${theme.palette.primary.boxShadow2Lite}`,
    '&:hover': {
      backgroundColor: theme.palette.secondary.contrastText,
    },
  },
  buttonSelected: {
    objectFit: 'scale-down !important',
    background: theme.palette.secondary.contrastText,
    textTransform: 'capitalize',
    borderRadius: '1000px',
    cursor: 'pointer',
    width: '74px',
    height: '74px',
    border: `2px solid ${theme.palette.secondary.activeSlide}`,
    padding: 0,
    '&:hover': {
      backgroundColor: theme.palette.secondary.contrastText,
    },
  },
  stockLabel: {
    background: theme.palette.primary.disableCTA,
    borderRadius: '16px',
    color: theme.palette.primary.textColor3,
    width: '4.68rem',
    position: 'absolute',
    padding: '3px 4px',
    top: '1rem',
    right: '1rem',
  },
  flashStockLabel: {
    background: theme.palette.primary.disableCTA,
    borderRadius: '16px',
    color: theme.palette.secondary.contrastText,
    position: 'absolute',
    padding: '3px 10px',
    top: '1rem',
    right: '1rem',
    minWidth: '3.68rem',
  },
  stockContainer: {
    minHeight: '1rem',
  },
  deviceCard: {
    overflow: 'visible',
    mt: '10px',
    position: 'relative',
    height: '100%',
    p: '14px .5rem .5rem',
    background: theme.palette.secondary.contrastText,
    boxShadow: `0px 5px 5px -3px  ${theme.palette.primary.boxShadow2Dark}, 0px 8px 10px 1px  ${theme.palette.primary.boxShadow2Medium}, 0px 3px 14px 2px  ${theme.palette.primary.boxShadow2Lite}`,
    borderRadius: '10px',
  },
  offerHeader: {
    position: 'absolute',
    height: 20,
    backgroundColor: theme.palette.primary.disableCTA,
    color: theme.palette.secondary.contrastText,
    width: '100%',
    m: '0 auto',
    textAlign: 'center',
    top: 0,
    left: 0,
    right: 0,
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
  },
  deviceMainDiv: {
    textDecoration: 'none',
    display: 'block',
  },
  deviceImage: { width: { md: 'fit-content' }, height: { md: 155 }, pt: { xs: 0 } },
  brandName: {
    color: theme.palette.primary.textColor3,
  },
  modelName: {
    color: theme.palette.secondary.mobileActiveToggleBackground,
    minHeight: '4rem',
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  },
  priceText: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.primary.textColor3,
  },
  price: {
    lineHeight: 'unset',
    color: theme.palette.primary.textColor3,
  },
  showMore: {
    m: '0 auto',
    textAlign: 'center',
    pt: '2rem',
    pb: '2rem',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  showMoreText: {
    color: theme.palette.primary.textColor3,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  faqContainerSuperMain: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '2rem',
  },
});

export default styles;
